export default [
  {
    path: '/admin/page-categories',
    name: 'indexPageCategoriesAdmin',
    meta: { title: 'indexPageCategoriesAdmin' },
    component: () => import('@/pages/admin/page-categories'),
  },
  {
    path: "/admin/page-categories/create",
    name: "createPageCategoriesAdmin",
    meta: { title: 'createPageCategoriesAdmin' },
    component: () => import('@/pages/admin/page-categories/create'),
  },
  {
    path: "/admin/page-categories/:id/edit",
    name: "editPageCategoriesAdmin",
    meta: { title: 'editPageCategoriesAdmin' },
    component: () => import('@/pages/admin/page-categories/edit'),
  },
]
